module.exports = __webpack_public_path__ + "files/d99127ab667c6c21c0c2d8dca30dcd3e.svg";